/*
 * @Author: your name
 * @Date: 2020-03-23 10:52:03
 * @LastEditTime: 2020-11-21 16:37:26
 * @LastEditors: wutt
 * @Description: In User Settings Edit
 * @FilePath: /DianZiDiTu/src/components/onlineMap/model/DataSource/WmtsServiceJs.js
 */
import { GuidUtility } from "../../../../utility/common/GuidUtility.js";
 import { WMTSLayerUtility } from "../../../../utility/common/WMTSLayerUtilityJs.js";
import { OLSourceType } from "./OLSourceTypeJs.js";
import { DataSourceInfo, DataSourceInfoFilter } from "./DataSourceInfoJs.js";
export class WmtsService extends DataSourceInfo {

    constructor() {
        super();

        this.epsg = "EPSG:4326";//空间参考epsg

        this.wmtsUrl = null;//url地址

        this.serviceName = null;//服务名称

        this.matrixSetName = 'default028mm';//矩阵集名称

        this.formatName = 'tiles';//格式名称

        this.tileSize = [256, 256];//单张切片大小

        this.tileGridExtent = null;//切片矩阵范围

        this.tileGridOrigin = null;//原点

        this.tileGridResolutions = null;//分辨率

        this.tileGridMatrixIds = null;

        //切片方案类型

        this.tileSchemeType = 'tdt_4326';//切片方案类型
        this.params_key_layer = "serviceName";// 为了wmts 或者 xyz 统一通过key取value


        this.token = null;
        this.params_key_token= null;
    }

    getGeometryType() {
        return null;
    }

    /**
     * 虚方法
     */
    getFields() {
        return new Array();
    }

    getRequestObject() {
        let requestObject = new WmtsService();
        DataSourceInfo.getBasicInfofromJson(requestObject, this);

        requestObject.epsg = this.epsg;
        requestObject.wmtsUrl = this.wmtsUrl;
        requestObject.serviceName = this.serviceName;
        requestObject.matrixSetName = this.matrixSetName;
        requestObject.formatName = this.formatName;
        requestObject.tileSize = this.tileSize;
        requestObject.tileGridExtent = this.tileGridExtent;
        requestObject.tileGridOrigin = this.tileGridOrigin;
        requestObject.tileGridResolutions = this.tileGridResolutions;
        requestObject.tileGridMatrixIds = this.tileGridMatrixIds;
        //切片方案类型
        requestObject.tileSchemeType = this.tileSchemeType;
        requestObject.token = this.token;

        return requestObject;
    }

    /**
   * 获取数值型
   */
    getNumberFields() {
        return new Array();
    }


    setAttributesFromScheme(schemeParams) {
        if (!schemeParams) return;
        
        this.tileSchemeType = schemeParams.type;
        this.tileSize = schemeParams.size;
        this.tileGridOrigin = schemeParams.origin;
        this.tileGridExtent = schemeParams.gridExtent;
        this.tileGridResolutions = schemeParams.resolutions;
        this.tileGridMatrixIds = schemeParams.matrix_ids;
        this.formatName = schemeParams.format;
        this.epsg=schemeParams.epsg;
    }

    getOLSource(olSourceType,callback) {

        let newOLSource = null;

        if (olSourceType === OLSourceType.source_wmts) {
            let wmtsUtility = new WMTSLayerUtility();
            wmtsUtility.epsg = this.epsg;
            wmtsUtility.formatName = this.formatName;
            wmtsUtility.matrixSetName = this.matrixSetName;
            wmtsUtility.serviceName = this.serviceName;
            wmtsUtility.tileGridExtent = this.tileGridExtent;
            wmtsUtility.tileGridMatrixIds = this.tileGridMatrixIds;
            wmtsUtility.tileGridOrigin = this.tileGridOrigin;
            wmtsUtility.tileGridResolutions = this.tileGridResolutions;
            wmtsUtility.tileSize = this.tileSize;
            wmtsUtility.wmtsUrl = this.wmtsUrl;
            wmtsUtility.token = this.token;
            wmtsUtility.params_key_token = this.params_key_token;

            newOLSource = wmtsUtility.createWmtsSource();
        }

        this.olSource = newOLSource;
        
        callback(this.olSource);

    }

    /**
     * @Author: wutt
     * @Date: 2020-11-20 10:26:22
     * @Description: 开放 拼接地址的方法
     */
    joinUrl(){
        let newOLSource = null;
            let wmtsUtility = new WMTSLayerUtility();       
            wmtsUtility.wmtsUrl = this.wmtsUrl;        
            wmtsUtility.params_key_token= this.params_key_token;
            wmtsUtility.token = this.token;

            newOLSource = wmtsUtility.joinUrl(); 
            return  newOLSource;     
    }

    static fromJson(jsonObject) {
        let wmtsService = null;
        if (!jsonObject) return;

        wmtsService = new WmtsService();
        super.getBasicInfofromJson(wmtsService, jsonObject);
        wmtsService.epsg = jsonObject.epsg;

        wmtsService.wmtsUrl = jsonObject.wmtsUrl;

        wmtsService.serviceName = jsonObject.serviceName;

        wmtsService.matrixSetName = jsonObject.matrixSetName;

        wmtsService.formatName = jsonObject.formatName;

        wmtsService.tileSize = jsonObject.tileSize;

        wmtsService.tileGridExtent = jsonObject.tileGridExtent;

        wmtsService.tileGridOrigin = jsonObject.tileGridOrigin;

        wmtsService.tileGridResolutions = jsonObject.tileGridResolutions;

        wmtsService.tileGridMatrixIds = jsonObject.tileGridMatrixIds;

        wmtsService.tileSchemeType = jsonObject.tileSchemeType;
        wmtsService.token =  jsonObject.token;
        wmtsService.params_value_layer =jsonObject.serviceName;
        wmtsService.params_key_token =jsonObject.params_key_token;
        return wmtsService;
    }
}

export class WmtsServiceFilter extends DataSourceInfoFilter {
    constructor() {
        super();
    }




}


// wmts方案类型
export const WMTSSchemeConfig = {




    findSchemeByType(schemeType) {
        let findItem = null;
        if (!schemeType) return findItem;

        let schemeParams = WMTSSchemeConfig.schemeParamsEx;

        let tempScheme = null;
        for (let tempIndex = 0; tempIndex < schemeParams.length; tempIndex++) {
            tempScheme = schemeParams[tempIndex];
            if (!tempScheme) continue;

            if (tempScheme.type === schemeType) {
                findItem = tempScheme;
                break;
            }
        }

        return findItem;

    },


    formatLabels: [{
        id: 0,
        label: "png格式",
        value: 'image/png'
    },
    {
        id: 1,
        label: "jpg格式",
        value: 'image/jpg'
    }, {
        id: 2,
        label: "jpeg格式",
        value: 'image/jpeg'
    },
    {
        id: 3,
        label: "gif格式",
        value: 'image/gif'
    },
    {
        id: 4,
        label: "tiles",
        value: 'tiles'
    }
    ],

    tileSizeLabels: [{
        id: 0,
        label: "128",
        value: [128, 128]
    },
    {
        id: 1,
        label: "256",
        value: [256, 256]
    },
    {
        id: 3,
        label: "512",
        value: [512, 512]
    },
    ],

    tileSchemeLabels: [{
        id: 0,
        label: "天地图经纬度",
        value: 'tdt_4326'
    },
    {
        id: 1,
        label: "天地图平面",
        value: 'tdt_3857'
    },
    {
        id: 2,
        label: "谷歌平面",
        value: 'ArcGIS_Online_Bing_Maps_Google_Maps'
    }

    ],

    schemeParams: [{
        'id': GuidUtility.getGuid(),
        'type': 'tdt_4326',
        'format': 'tiles',
        'epsg':'EPSG:4326',
        'size': [256, 256],
        'origin': [-180, 90],
        'gridExtent': [-180.0, -90.0, 180.0, 90.0],
        'resolutions': [1.406249999978297, 0.7031249999891485, 0.35156249999999994, 0.17578124999999997, 0.08789062500000014, 0.04394531250000007, 0.021972656250000007, 0.01098632812500002, 0.00549316406250001, 0.0027465820312500017, 0.0013732910156250009, 0.000686645507812499, 0.0003433227539062495, 0.00017166137695312503, 0.00008583068847656251, 0.000042915344238281406, 0.000021457672119140645, 0.000010728836059570307, 0.000005364418029785169, 0.0000026822090148925845, 0.000001341104532462678, 0.00000067, 0.00000033, 0.00000016],
        'matrix_ids': [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
    }, {
        'id': GuidUtility.getGuid(),
        'type': 'tdt_3857',
        'format': 'tiles',
        'epsg':'EPSG:3857',
        'size': [256, 256],
        'origin': [-20037508.3427892, 20037508.3427892],
        'gridExtent': [-20037508.3427892, -20037508.3427892, 20037508.3427892, 20037508.3427892],
        'resolutions': [78271.516963999893, 39135.758482000099, 19567.879240999901, 9783.9396204999593, 4891.9698102499797, 2445.9849051249898, 1222.9924525624899, 611.49622628138002, 305.74811314055802, 152.874056570411, 76.437028285073197, 38.218514142536598, 19.109257071268299, 9.5546285356341496, 4.7773142679493699, 2.38865713397468, 1.1943285668550501, 0.59716428355981699, 0.29858214164761698],
        'matrix_ids': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
    },
    {
        'id': GuidUtility.getGuid(),
        'type': 'ArcGIS_Online_Bing_Maps_Google_Maps',
        'format': 'image/png',
        'epsg':'EPSG:3857',
        'size': [256, 256],
        'origin': [-20037508.342787, 20037508.342787],
        'gridExtent': [-20037508.342787001, -20037508.342787001, 20037508.342787001, 20037508.342787001],
        'resolutions': [156543.033928, 78271.5169639999, 39135.7584820001, 19567.8792409999, 9783.93962049996, 4891.96981024998, 2445.98490512499, 1222.99245256249, 611.49622628138, 305.748113140558, 152.874056570411, 76.4370282850732, 38.2185141425366, 19.1092570712683, 9.55462853563415, 4.77731426794937, 2.38865713397468, 1.19432856685505, 0.597164283559817, 0.298582141647617],
        'matrix_ids': [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]

    }

    ],
    schemeParamsEx:[
        {
            'id': GuidUtility.getGuid(),
            'type': 'tdt_4326',
            'format': 'tiles',
            'epsg':'EPSG:4326',
            'size': [256, 256],
            'origin': [-180, 90],
            'gridExtent': [-180.0, -90.0, 180.0, 90.0],
            'resolutions': [
                0.7031249999891485,
                0.35156249999999994,
                0.17578124999999997,
                0.08789062500000014,
                0.04394531250000007,
                0.021972656250000007,
                0.01098632812500002,
                0.00549316406250001,
                0.0027465820312500017,
                0.0013732910156250009,
                0.000686645507812499,
                0.0003433227539062495,
                0.00017166137695312503,
                0.00008583068847656251,
                0.000042915344238281406,
                0.000021457672119140645,
                0.000010728836059570307,
                0.000005364418029785169,
                0.0000026822090148925845,
                0.000001341104532462678
            ],
            'matrix_ids': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,20]
        }, {
            'id': GuidUtility.getGuid(),
            'type': 'tdt_3857',
            'format': 'tiles',
            'epsg':'EPSG:3857',
            'size': [256, 256],
            'origin': [-20037508.3427892, 20037508.3427892],
            'gridExtent': [-20037508.3427892, -20037508.3427892, 20037508.3427892, 20037508.3427892],
            'resolutions': [78271.516963999893, 39135.758482000099, 19567.879240999901, 9783.9396204999593, 4891.9698102499797, 2445.9849051249898, 1222.9924525624899, 611.49622628138002, 305.74811314055802, 152.874056570411, 76.437028285073197, 38.218514142536598, 19.109257071268299, 9.5546285356341496, 4.7773142679493699, 2.38865713397468, 1.1943285668550501, 0.59716428355981699, 0.29858214164761698],
            'matrix_ids': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
        },
        {
            'id': GuidUtility.getGuid(),
            'type': 'ArcGIS_Online_Bing_Maps_Google_Maps',
            'format': 'image/png',
            'epsg':'EPSG:3857',
            'size': [256, 256],
            'origin': [-20037508.342787, 20037508.342787],
            'gridExtent': [-20037508.342787001, -20037508.342787001, 20037508.342787001, 20037508.342787001],
            'resolutions': [156543.033928, 78271.5169639999, 39135.7584820001, 19567.8792409999, 9783.93962049996, 4891.96981024998, 2445.98490512499, 1222.99245256249, 611.49622628138, 305.748113140558, 152.874056570411, 76.4370282850732, 38.2185141425366, 19.1092570712683, 9.55462853563415, 4.77731426794937, 2.38865713397468, 1.19432856685505, 0.597164283559817, 0.298582141647617],
            'matrix_ids': [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
    
        }
    ]
}